import React from 'react';
import {CheckoutButton} from './CheckoutButton/CheckoutButton';
import {CashierExpressButtons} from '../CashierExpressButtons/CashierExpressButtons';
import {useControllerProps} from '../../ControllerContext';
import s from './CheckoutButtons.scss';
import {useEnvironment} from '@wix/yoshi-flow-editor';

export enum CheckoutButtonsDataHook {
  Default = 'CheckoutButtons.default',
  Top = 'CheckoutButtons.topView',
}

interface CheckoutButtonsProps {
  isOnTop?: boolean;
}

export function CheckoutButtons(props: CheckoutButtonsProps) {
  const {shouldShowDynamicPaymentOptions} = useControllerProps().cashierExpressStore;
  const {isSSR} = useEnvironment();
  const {isCheckoutRegularFlowEnabled} = useControllerProps().cartStore;
  const {isOnTop} = props;
  const dataHook = isOnTop ? CheckoutButtonsDataHook.Top : CheckoutButtonsDataHook.Default;
  const {isCheckoutButtonDisabled} = useControllerProps().navigationStore;
  const {isLoading} = useControllerProps();
  return (
    <div data-hook={dataHook} className={s.checkoutButtons}>
      {isCheckoutRegularFlowEnabled && <CheckoutButton disabled={isCheckoutButtonDisabled || isLoading} />}
      {shouldShowDynamicPaymentOptions && !isSSR ? <CashierExpressButtons /> : null}
    </div>
  );
}
